<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <svg
    :width="width"
    :height="height"
    class="group"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :class="styles"
      d="M21.5999 8.84765V17.4C21.5999 18.1957 21.2838 18.9588 20.7212 19.5214C20.1586 20.084 19.3956 20.4 18.5999 20.4H5.3999C4.60425 20.4 3.84119 20.084 3.27858 19.5214C2.71597 18.9588 2.3999 18.1957 2.3999 17.4V8.84765L11.6951 14.3172C11.7874 14.3717 11.8927 14.4004 11.9999 14.4004C12.1071 14.4004 12.2124 14.3717 12.3047 14.3172L21.5999 8.84765ZM18.5999 4.80005C19.3381 4.79993 20.0504 5.07198 20.6005 5.56414C21.1507 6.0563 21.5001 6.73402 21.5819 7.46765L11.9999 13.104L2.4179 7.46765C2.49969 6.73402 2.84909 6.0563 3.39926 5.56414C3.94942 5.07198 4.66173 4.79993 5.3999 4.80005H18.5999Z"
    />
  </svg>
</template>

<script lang="ts" setup>
import { defineProps, computed, toRefs } from "vue";
export interface IconLinkProps {
  color?: string;
  width?: string;
  height?: string;
  classes?: string;
}

const props = withDefaults(defineProps<IconLinkProps>(), {
  color: "white",
  width: "100%",
  height: "100%",
});

const { color, width, height, classes } = toRefs(props);
const styles = computed(() => {
  return `${color.value} group-hover:fill-orange transition-colors ${classes?.value}`;
});
</script>
